import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, Autocomplete } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCustomers } from '../../../redux/Slice/customerSlice';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import { fetchInspirationTemplates } from '../../../redux/Slice/InspirationTemplate';
import { Editor } from '@monaco-editor/react';
import { setLoading } from '../../../redux/Slice/loaderSlice';
import { addInspiration, confirmInspiration } from '../../../redux/Slice/inspirationSlice';

const AddInspiration = () => {
    const dispatch = useDispatch();
    const { customers } = useSelector((state) => state.customer); // Assume customers list is in the Redux store
    const { Inspirationtemplates } = useSelector((state) => state.inspirationTemplate); // Assume customers list is in the Redux store
    const [response, setResponse] = useState(null);
    const [image, setImage] = useState(null);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setImage(imageUrl);
        }
    };
    const defaultOption = { companyName: 'Default', _id: 0 };
    const [formData, setFormData] = useState({
        customer: null,
        template: null,
        data: '',
    });

    useEffect(() => {
        // Dispatch an action to fetch the customer list
        dispatch(fetchCustomers());
        dispatch(fetchInspirationTemplates());
    }, [dispatch]);

    const handleChange = (field) => (event, value) => {
        console.log(event.target.value);
        setFormData((prev) => ({
            ...prev,
            [field]: value ? value.id || value._id : null, // Use id/_id depending on the field
        }));
        console.log(formData)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log('Form Data:', formData);
        dispatch(setLoading(true));
        // Dispatch an action to handle form submission
        dispatch(addInspiration(formData)).then((res) => {
            console.log(res.payload.data);
            setResponse(JSON.stringify(res.payload.data, null, 2))
            dispatch(setLoading(false));
        })
    };
    const handleConfrimSubmit = (event) => {
        event.preventDefault();
        dispatch(setLoading(true));
        const formData = {
            data: response,
        };
        // Dispatch an action to handle form submission
        dispatch(confirmInspiration(formData)).then((res) => {
            console.log(res);
            dispatch(setLoading(false));
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
            }}>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    gap: 2,
                    pr: 4,
                    width: "70%",
                    height: "100%",
                }}>
                <Typography variant="h4" gutterBottom>
                    Add Inspiration
                </Typography>

                <Autocomplete
                    style={{
                        position: "fixed",
                        top: "65px",
                        right: "100px",
                        width: "200px",
                    }}
                    options={[...customers, defaultOption]}
                    variant="standard"
                    getOptionLabel={(option) => option.companyName}
                    value={[...customers, defaultOption].find(
                        (c) => c.id === formData.customer
                    )} // Find selected option by id
                    onChange={handleChange("customer")}
                    renderInput={(params) => (
                        <TextField {...params} label="Customer" required />
                    )}
                    filterOptions={(options, state) => {
                        const filtered = options.filter((option) =>
                            option.companyName && option.companyName
                                .toLowerCase()
                                .includes(state.inputValue.toLowerCase())
                        );
                        // If no matches, include the default option
                        if (filtered.length === 0 && state.inputValue.trim() !== "") {
                            return [defaultOption];
                        }
                        return filtered;
                    }}
                />
                <Autocomplete
                    options={Inspirationtemplates}
                    variant="outlined"
                    getOptionLabel={(option) => option.templateName}
                    value={
                        Inspirationtemplates.find((t) => t._id === formData.template) || null
                    } // Find selected template by _id
                    onChange={handleChange("template")}
                    renderInput={(params) => (
                        <TextField {...params} label="Template" required />
                    )}
                />

                {image ? (
                    <Box mt={2}>
                        <img src={image} alt="Uploaded" style={{ maxWidth: "100%", height: "auto" }} />
                        <Button variant="contained" color="error" onClick={() => setImage(null)}>
                            Change Image
                        </Button>
                    </Box>
                ) : <Box mt={2}>
                    <input
                        accept="image/*"
                        type="file"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                        id="image-upload"
                    />
                    <label htmlFor="image-upload">
                        <Button variant="contained" component="span" color="secondary">
                            Upload Image
                        </Button>
                    </label>
                </Box>  }
                <Button type="submit" variant="contained" color="primary">
                    Submit
                </Button>
            </Box>
            <Box
                component="form"
                onSubmit={handleConfrimSubmit}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    height:"70vh",
                    width: "100%",
                    
                }}>
                <Editor
                    language="text"
                    style={{ border: "1px solid #ccc", boxshadow: "5px 5px 10px rgba(0,0,0,0.1)", }}
                    value={response || ""}
                    onChange={(value) => setResponse(value)}
                    height="400px"
                />
                <Button variant='contained' color='primary' type="submit">submit</Button>
            </Box>
        </Box>
    );
};

export default AddInspiration;
